import React, { useRef } from 'react';
import GuestHeader from './GuestHeader';
import GuestFooter from './GuestFooter';
import './GuestChristmasSongs.css';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const GuestChristmasSongs = () => {
    const contentRef = useRef(null);

    const handleDownloadPDF = async () => {
        if (!contentRef.current) return;

        try {
            // Show loading state
            const downloadBtn = document.querySelector('.download-pdf-btn');
            if (downloadBtn) {
                downloadBtn.innerHTML = '<i class="fas fa-spinner fa-spin me-2"></i>Generating PDF...';
                downloadBtn.disabled = true;
            }

            // Get all song cards
            const songCards = contentRef.current.querySelectorAll('.song-card');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const margin = 15;
            const contentWidth = pageWidth - (2 * margin);

            // Load logo image
            const logoImg = new Image();
            logoImg.src = './assets/images/logo_custom_new_trans.png';
            await new Promise((resolve) => {
                logoImg.onload = resolve;
            });

            let isFirstPage = true;

            for (let i = 0; i < songCards.length; i++) {
                if (!isFirstPage) {
                    pdf.addPage();
                }

                // Add church header to each page
                const logoHeight = 15;
                const logoAspectRatio = logoImg.width / logoImg.height;
                const logoWidth = logoHeight * logoAspectRatio;

                // Logo on the left
                pdf.addImage(logoImg, 'PNG', margin, margin, logoWidth, logoHeight);

                // Text aligned with logo
                const textX = margin + logoWidth + 5;
                const textStartY = margin + 5;

                pdf.setFontSize(14);
                pdf.setTextColor(139, 0, 0);
                pdf.setFont('helvetica', 'bold');
                pdf.text('MOR BASELIOS JSOC DERBY', textX, textStartY);

                pdf.setFontSize(9);
                pdf.setTextColor(100, 100, 100);
                pdf.setFont('helvetica', 'normal');
                pdf.text('Christmas Songs Collection', textX, textStartY + 5);

                // Add watermark
                const watermarkSize = 80;
                pdf.saveGraphicsState();
                pdf.setGState(new pdf.GState({ opacity: 0.05 }));
                pdf.addImage(
                    logoImg,
                    'PNG',
                    (pageWidth - watermarkSize) / 2,
                    (pageHeight - watermarkSize) / 2,
                    watermarkSize,
                    watermarkSize
                );
                pdf.restoreGraphicsState();

                // Capture song card as canvas
                const card = songCards[i];
                const canvas = await html2canvas(card, {
                    scale: 3,              // Increase from 2 to 3 for larger/sharper text
                    useCORS: true,
                    logging: false,
                    backgroundColor: '#ffffff'
                });

                const imgData = canvas.toDataURL('image/png');
                const imgWidth = contentWidth;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;

                // Position content below header
                const yPosition = margin + logoHeight + 8;
                const availableHeight = pageHeight - yPosition - margin;

                if (imgHeight <= availableHeight) {
                    pdf.addImage(imgData, 'PNG', margin, yPosition, imgWidth, imgHeight);
                } else {
                    const scaledHeight = availableHeight;
                    const scaledWidth = (canvas.width * scaledHeight) / canvas.height;
                    pdf.addImage(imgData, 'PNG', margin, yPosition, scaledWidth, scaledHeight);
                }

                isFirstPage = false;
            }

            // Save the PDF
            pdf.save('Christmas_Songs_MorBaselios_Derby.pdf');

            // Reset button state
            if (downloadBtn) {
                downloadBtn.innerHTML = '<i class="fas fa-download me-2"></i>Download as PDF';
                downloadBtn.disabled = false;
            }
        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('Error generating PDF. Please try again.');

            const downloadBtn = document.querySelector('.download-pdf-btn');
            if (downloadBtn) {
                downloadBtn.innerHTML = '<i class="fas fa-download me-2"></i>Download as PDF';
                downloadBtn.disabled = false;
            }
        }
    };

    const songs = [
        {
            id: 1,
            title: "പുൽക്കുടിലിൽ",
            content: `പുൽക്കുടിലിൽ... കൽത്തൊട്ടിയിൽ...
മറിയത്തിൻ പൊന്മകനായ്...
പണ്ടൊരുനാൾ.. ദൈവസുതൻ...
പിറന്നതിനോർമ്മ ദിനം...

പോരൂ മന്നിലെയിടയന്മാരെ
പാടു വിണ്ണിലെ മാലാഖകളെ...(2)
പാടു... തംബുരുവും... കിന്നരവും താളവുമായ്...(2)


മെല്ഷ്യരും കാസ്‌പറും
ബെൽത്തസറും വാഴ്ത്തും
പുൽക്കുടിലിൽ...
രക്ഷകരിൽ രക്ഷകനാം
മിശിഹാ പിറന്ന ദിനം

(പോരൂ മന്നിലെയിടയന്മാരെ)


ഭൂമിയിൽ ദൈവമക്കൾ
നേടും സമാധാനം
ഉന്നതിയിൽ അത്യുന്നതിയിൽ
ദൈവത്തിനു മഹത്വം...

(പോരൂ മന്നിലെയിടയന്മാരെ)`
        },
        {
            id: 2,
            title: "കണ്ണും കണ്ണും കാത്തിരുന്നു",
            content: `കണ്ണും കണ്ണും കാത്തിരുന്നു
മണ്ണിലൊരു പൈതലിനായ്
കാതോട് കാതോരം കാത്തിരുന്നു
ദൈവ പുത്രൻ പിറക്കുമെന്ന് (2) കണ്ണും കണ്ണും

ആകാശ വീഥിയിൽ മാലാഖമാരവർ
സ്നേഹത്തിൻ നിറകുടമായി
താരാട്ടു പാടി ഉറക്കിടുവാനായി
മനതാരിൽ നിനച്ചിരുന്നു

ഇത്ര നല്ല സ്നേഹേത്തെ തന്ന നല്ല നാഥനെ
മെല്ലെ രാവിൽ പാടിസ്‌തുതിക്കാം (2) കണ്ണും കണ്ണും

ജീവന്റെ പാതയിൽ കാരുണ്യവാനായി
കരുണാദ്രൻ അലിഞ്ഞദിനം
ആലോലമാട്ടി ലാളിച്ചീടുവാനായി
കൃപയിൽ നിറഞ്ഞിരുന്നു

ഇത്ര നല്ല സ്നേഹേത്തെ തന്ന നല്ല നാഥനെ
മെല്ലെ രാവിൽ പാടിസ്‌തുതിക്കാം (2) കണ്ണും കണ്ണും`
        },
        {
            id: 3,
            title: "ദൈവം പിറക്കുന്നു മനുഷ്യനായി ബെത്ലഹേമിൽ",
            content: `ദൈവം പിറക്കുന്നു മനുഷ്യനായി ബെത്ലഹേമിൽ.
മഞ്ഞുപെയ്യുന്ന മലമടക്കിൽ .. ഹല്ലേലൂയാ.. ഹല്ലേലൂയാ
മണ്ണിലും വിണ്ണിലും മന്ദഹാസം പെയ്യും മധുരമനോഹരഗാനം..
ഹല്ലേലൂയാ..ഹല്ലേലൂയാ... (ദൈവം പിറക്കുന്നു)

പാതിരാവിൻ മഞ്ഞേറ്റീറനായ്.. പാരിൻ്റെ നാഥൻ പിറക്കുകയായ് (2)
പാടിയാർക്കു വീണമീട്ടു. . ദൈവത്തിൻ ദാസരെ ഒന്നു ചേരൂ (2)
                            (ദൈവം പിറക്കുന്നു)

പകലോനു മുൻപേ പിതാവിൻ്റെ ഹൃത്തിലെ ശ്രീയേകസുനുവാമുദയസൂര്യൻ (2)
പ്രാഭവപൂർണ്ണനായ് ഉയരുന്നിതാ പ്രതാപമോടിന്നേശുനാഥൻ (2)
                            (ദൈവം പിറക്കുന്നു)`
        },
        {
            id: 4,
            title: "യഹൂദിയായിലെ ഒരു ഗ്രാമത്തിൽ",
            content: `യഹൂദിയായിലെ ഒരു ഗ്രാമത്തിൽ
ഒരു ധനുമാസത്തിൻ കുളിരും രാവിൽ
രാപാർത്തിരുന്നോരജപാലകർ
ദേവനാദം കേട്ടു, ആമോദരായ്

വർണ്ണരാജികൾ വിടരും വാനിൽ
വെള്ളിമേഘങ്ങൾ ഒഴുകും രാവിൽ
താരക രാജകുമാരിയോടൊത്തന്ന്
തിങ്കൾ കല പാടി ഗ്ലോറിയാ
അന്നു തിങ്കൾ കല പാടി ഗ്ലോറിയാ

താരകം തന്നെ നോക്കീ ആട്ടിടയർ നടന്നു (2)
തേജസു മുന്നിൽക്കണ്ടു
അവർ ബത്ലഹേം തന്നിൽ വന്നു.
രാജാധിരാജന്റെ പൊൻ തിരുമേനി (2)
അവർ കാലിത്തൊഴുത്തിൽ കണ്ടു
                (വർണ്ണരാജികൾ വിടരും...)

മന്നവർ മൂവരും ദാവീദിൻ സുതനേ (2)
കണ്ടു വണങ്ങിടുവാൻ അവർ കാഴ്‌ചയുമായ് വന്നു (2)
ദേവാധിദേവന്റെ തിരുസന്നിധിയിൽ (2)
അവർ കാഴ്‌ചകൾ വച്ചു വണങ്ങി
(യഹൂദിയായിലെ...)`
        },
        {
            id: 5,
            title: "രാജാവിൻ രാജാവെഴുന്നള്ളുന്നു",
            content: `രാജാവിൻ രാജാവെഴുന്നള്ളുന്നു
ദേവന്റെ ദേവൻ എഴുന്നള്ളുന്നു
മലർ വീഥിയൊരുക്കി മാലാഖമാർ
പുൽമെത്ത വിരിച്ചു ഇടയന്മാർ

ഹാലേലൂയ്യാ....... (3)
ഹാ...ലേ... ലൂയ്യാ..... (രാജാവിൻ .....)

കന്യാമറിയത്തിൻ പുണ്യപുത്രൻ
കൈവല്യരൂപനായ് അവതരിച്ചു.....(2)
കാലിത്തൊഴുത്തിലെ കൂരിരുട്ടിൽ
കാലത്തിൻ സ്വപ്‌പ്നം തിളങ്ങിയല്ലോ... (2)..... (രാജാവിൻ...)

കിഴക്കുനിന്നെത്തിയ രാജാക്കന്മാർ
കുഞ്ഞിളം പാദങ്ങൾ തൊഴുതുനിന്നു.... (2)
കുന്തിരിക്കം കാഴ്ച്‌ച കൊണ്ടുവന്നു
മീറയും സ്വർണ്ണവും കൊണ്ടുവന്നു... (2).... (രാജാവിൻ...)`
        },
        {
            id: 6,
            title: "ബേത്ലഹേം പൂരിയിലായ് വന്നുപിറന്നുണ്ണിയേശു",
            content: `ബേത്ലഹേം പൂരിയിലായ് വന്നുപിറന്നുണ്ണിയേശു
ലോകപാപം തീർത്തിടുവാൻ പാരിതിൽ മനുജനായ്
വന്നല്ലോ ഈരാവിൽ നാഥൻ...
മറിയത്തിൻ മകനായി മന്നീൽ
പോയിടാം കൂട്ടരേ സ്വർലോകനാഥന്റെ
ജനനത്തെ ലോകമെങ്ങും ഘോഷിച്ചിടാം (2)
തപ്പുതാളമേളമോടെ ഒത്തുചേർന്ന് പാടിടാം
സ്വർഗ്ഗനാഥൻ ഭൂവിൽ വന്ന സുദിനം
ആർത്തുപാടി ഘോഷിച്ചിടാം..
ആർത്തുപാടി ഘോഷിച്ചിടാം..

രാജാധിരാജാവാം ശ്രീയേശുനാഥന്റെ
തൃപ്പാദം കുമ്പിട്ടിടാം... (2)
ആമോദരായിന്ന് ആനന്ദഗീതികളാൽ
സാമോദം വാഴ്ത്തിപ്പാടാം (2)
                (പോയിടാം കൂട്ടരേ)

അജപാലരെല്ലാരും ആഹ്ളാദത്താലിന്ന്
നാഥനെ സ്‌തുതിച്ചിടുന്നു (2)
ശാസ്ത്രിമാർ മൂവരും കാഴ്‌ചകളർപ്പിച്ച്
രാജനെ വന്ദിക്കുന്നു (2)
                (പോയിടാം കൂട്ടരേ)`
        }, {
            id: 7,
            title: "ശാന്തരാത്രി തിരുരാത്രി",
            content: `ശാന്തരാത്രി തിരുരാത്രി
പുൽക്കുടിലിൽ പൂത്തൊരു രാത്രി...
വിണ്ണിലെ താരകദൂതരിറങ്ങിയ
മണ്ണിൻ സമാധാനരാത്രി
ഉണ്ണി പിറന്നു- ഉണ്ണിയേശുപിറന്നു...
ഉണ്ണി പിറന്നു- ഉണ്ണിയേശുപിറന്നു...
ഉണ്ണി പിറന്നു- ഉണ്ണിയേശുപിറന്നു...

ദാവീദിൻ പട്ടണം പോലെ
പാതിരാവിൻ മഞ്ഞേറ്റീറനായ്.. പാരിൻ്റെ നാഥൻ പിറക്കുകയായ് (2)
പാതിരാവിൻ മഞ്ഞേറ്റീറനായ്.. പാരിൻ്റെ നാഥൻ പിറക്കുകയായ് (2)
വീഞ്ഞു പകരുന്ന മഞ്ഞിൽ മുങ്ങി
വീണ്ടും മനസ്സുകൾ പാടി (2)
ഉണ്ണി പിറന്നു- ഉണ്ണിയേശുപിറന്നു...
ഉണ്ണി പിറന്നു- ഉണ്ണിയേശുപിറന്നു...
ഉണ്ണി പിറന്നു- ഉണ്ണിയേശുപിറന്നു...

കുന്തിരിക്കത്താലെഴുതീ...
സന്ദേശഗീതത്തിൽ പൂവിടർത്തി..(2)
ദൂരെനിന്നായിരം അഴകിൻ കൈകൾ
എങ്ങും ആശംസ തൂകി (2)
ഉണ്ണി പിറന്നു- ഉണ്ണിയേശുപിറന്നു...
ഉണ്ണി പിറന്നു- ഉണ്ണിയേശുപിറന്നു...
ഉണ്ണി പിറന്നു- ഉണ്ണിയേശുപിറന്നു...`
        },
        {
            id: 8,
            title: "ഇന്നിതാ വിൺസുതൻ ജാതനായി",
            content: `ഇന്നിതാ വിൺസുതൻ ജാതനായി
കന്യമേരി തൻ കണ്മണിയായി -2

ഉന്നത വീഥിയിലതി മഹത്വം
മന്നിതിൽ മാനവർക്ക് അതി സന്തോഷം-2
പാതിരാ പക്ഷികൾ പാടിടുമ്പോൾ
പരിപാവന രൂപൻ ഉറങ്ങി-2       (ഇന്നിതാ)

ചെമ്പക പൂമര കൊമ്പുകളിൽ
അമ്പിളി കല നല്ലൊരു ഊഞ്ഞാലു കെട്ടി-2
ഇമ്പമായ് ഗാനങ്ങൾ മൂളി മൂളീ
മന്ദമാരുതൻ ഊഞ്ഞാലിലാടി-2 (ഇന്നിതാ)`
        },
        {
            id: 9,
            title: "ഇന്നു രാവിൽ കുഞ്ഞാറ്റ (ഏക് ദോ തീൻ...)",
            content: `ഇന്ന് രാവിൽ കുഞ്ഞാറ്റ കിളികളും കാട്ടു പൂവും 
കഥ പാടുന്നേ (2)
താരപഥം താലോലിക്കാം നാഥനെ മാലാഖമാർ വരവേൽക്കുന്നെ(2) (ഇന്ന് )

പൂതിങ്കൾ പൂമാല എകുന്നിതാ പൂവായ പൂവൊക്കെ തേടുന്നിത 
ഈരാവിൽ വെണ്മേഘം ചാഞ്ചടുന്നു ഇളംകാറ്റിൽ കിങ്ങിണി ആടും പോലെ 
ആനന്ദത്താൽ പാടുന്നിത പാതിരാ പൂക്കളും പൂകൈതയും (2) (ഇന്ന് )

ഈ നല്ല രാത്രിയിൽ ഈ യമത്തിൽ ഈറെന മേഘങ്ങൾ കൈകൂപ്പുമ്പോൾ 
ബെത്‌ലഹേം എന്നൊരു ഗോശാലയിൽ രാജാധിരാജൻ ഇന്നവതരിച്ചു 
കുഞ്ഞാടുകൾ കൂത്താടുന്നു നാഥനെ കുഞ്ഞിളം കാറ്റീണം പാടി (2)
(ഇന്നുരാവിൽ കുഞ്ഞാറ്റ കിളികളും കാട്ടു പൂവും )`
        },
        {
            id: 10,
            title: "മുത്തേ മുത്തേ മുത്തേ",
            content: `മുത്തേ മുത്തേ മുത്തേ മുത്തേ പൊന്നോമനെ
നിന്നെ കാണാൻ കൊതിച്ചൊരു നാളിൽ
മഞ്ഞു പെയ്യുന്ന താഴ്വരയിൽ
ഒരു ജീവന്റെ കളിയാട്ടമായ്
(മുത്തേ മുത്തേ ചക്കര മുത്തേ) (2)

ദൂരെ ദൂരെ നിന്നും താരകങ്ങൾ പാടി
രാജാധി രാജാവിവൻ
മുത്തേ മുത്തേ
സ്നേഹത്തിൻ തൂലിക മന്നിൽ ചലിപ്പിച്ച
ദൈവാധിദൈവമിവൻ (2)

മണ്ണിൽ സ്നേഹം എന്നും വാരി ചൊരിഞ്ഞിടും
സ്വർഗ്ഗീയ നായകനായ്
(മുത്തേ മുത്തേ ചക്കര മുത്തേ) (2)
മുത്തേ മുത്തേ

താഴെ ഇന്നു മന്നിൽ മാലോകരെല്ലാം
അലിവേറും നാഥനായ്
കൈത്താളമോടെ വൈക്കോലുകൊണ്ടൊരു
പുൽക്കൂട് പണിതിരുന്നു

സ്വർണ്ണ വർണ്ണം ഏറും പുൽക്കൂട്ടിൽ വാഴുന്ന
ഉലകിന്റെ അധിപതിയെ
(മുത്തേ മുത്തേ ചക്കര മുത്തേ) (2)
മുത്തേ മുത്തേ`
        }, {
            id: 11,
            title: "താരങ്ങളെ ഒരു",
            content: `താരങ്ങളെ ഒരു താരാട്ടുമായ്
ഇന്ന് താഴേയ്ക്ക് വന്നീടുമോ
താരാജാലം മെല്ലെ മെല്ലെ പാടും
സ്വർഗ്ഗിയ സംഗീതമായ്
(താരങ്ങളെ )|

ആ വഴിത്താരയിൽ ഞാനൊരു ലില്ലി
പുഷ്പമായ് വിരിഞ്ഞിരുന്നെങ്കിൽ
താരിളം തെന്നലോടൊന്നു ചേർന്നിന്നാ
പുൽക്കൂടു തേടിപ്പോയേനേ (2)

ഇ ദിവ്യ നാളിൻന്റെ മാധുര്യമെല്ലാം
നെഞ്ചിലേറ്റി ഞാനിന്നു ചെന്നേനെ
 (താരങ്ങളെ)

ആ നീല രാവിൽ ഞാനൊരു താരാ
ജാലമായി തെളിഞ്ഞിരുന്നെങ്കിൽ
പാരിൻന്റെ നാഥനു വെൺശോഭയേകി
പുൽക്കൂട്ടിൽ വിളങ്ങി നിന്നേനെ (2)

ഈ ദിവ്യ രാവിൻന്റെ മാധുര്യമെല്ലാം
നെഞ്ചിലേറ്റി ഞാനിന്നു നിന്നേനെ (2)
(താരങ്ങളെ)
`
        }, {
            id: 12,
            title: "ഉണ്ണി യേശു പിറന്നൊരു രാവല്ലോ -tune രാവിൻ പൂന്തேன் ",
            content: `ഉണ്ണി യേശു പിറന്നൊരു രാവല്ലോ
ലോക രക്ഷക്കായി ഇനി അവനില്ലേ 
കൈ കൊട്ടി പാടാം താളത്തിൽ ആ-ടാം 
ഹല്ലേലുയ്യാ-പാടി ആനന്ദിച്ചീ-ടം
ലോക പാപങ്ങൾ മായ്ക്കുവാനായി
നാഥൻ ഭൂജാതനായി...
പോരുന്നോ മാളോരെ
നാമം വാഴ്ത്തിപാടാൻ 
(ഉണ്ണിയേശു പിറന്നൊരു)

മാനത്തു താരങ്ങൾ മിന്നി തിളങ്ങി തെളിഞ്ഞു
ഭൂവാകെ നാഥന്റെ നാമം ആമോദത്തോടേറ്റു പാടി(2)
ബെതിലഹേമിലെ കാലിതൻകൂട്ടിൽ
ദൈവപുത്രൻ അവതരിച്ചു
പൊൻമൂരുകുന്തിരിക്കം കാഴ്ചയുമായി വന്നു
മൂന്ന് രാജാക്കൾ വണങ്ങി നിന്നു
ഉണ്ണി യേശു പിറന്ന തിരുദിനം
ലാ ലാ ലാ ലാ ലലലലാ
(ഉണ്ണിയേശു പിറന്നൊരു)

മാനത്തെ മാറാപ്പിൽ നിന്നും തൂമഞ്ഞു പെയ്യുന്ന രാവിൽ
നാഥന്റെ തേജസ്സാൽ സ്നേഹം നിറയുന്നീലോകമാകെ (2)
ആട്ടിടയന്മാർ താണുവണങ്ങി 
ദൈവ സൂനുവേ വരവേറ്റു
ദൂതഗണങ്ങൾ കിന്നരം മീട്ടി
ലോക നാഥനു സ്തുതി പാടി
ശ്രീ യേശു മഹേശൻ പിറന്നിതാ
ലാ ലാ ലാ ലാ ലലലലാ
(ഉണ്ണി യേശു പിറന്നൊരു)`
        },
        {
            id: 13,
            title: "തിങ്കൾ കലയുടെ തേരിൽ ",
            content: `തിങ്കൾ കലയുടെ തേരിൽ ഇതാ 
തങ്കത്തിൻ പൂത്താലം ഏന്തിവന്നു 
പുഞ്ചിരിയുടെ മധു പാത്രവുമായി 
പൂത്താലമേന്തി കാറ്റു വന്നു 

വിണ്ണിലെ രാജകുമാരണവൻ 
മന്നിതിൽ ആകത്തനായല്ലോ 
നരകുല പാപം അകറ്റിടുവാൻ 
ധരായതിൽ അകെ കുളിർ പകരാൻ  (2 )

തന താന് ഓഹ് ..........

(തിങ്കൾ കലയുടെ) `
        },
        {
            id: 14,
            title: "വന്നല്ലോ ക്രിസ്മസ് tune എല്ലാരും ചൊല്ലണ് Neelakuzyil",
            content: `വന്നല്ലോ ക്രിസ്മസ് വനല്ലോ ക്രിസ്തുമസ്
മംഗള മോതിടുന്നേ.. നവ മംഗളം .....
നവ മംഗള മോതിടുന്നേ
പൊന്നിൻപുലരിയിൽപുഞ്ചിരിതുക്കുന്ന
ബേത്ലഹേമിലിതാ.. യേശു
ബേത്ലഹേമിലിതാ...

പഞ്ചമം പാടുന്നു പഞ്ചമം പാടുന്നു
പൂങ്കയിൽ പാടിടുന്നേ.. പുത്തൻ പൂങ്കുയിൽ
പുത്തൻ പൂങ്കുയിൽ പാടിടുന്നേ...
അക്കൊച്ചു കൺകളിലുമ്മ വച്ചീടുവാൻ
താരങ്ങളുണർന്നു വീണു.. തങ്ക താരങ്ങൾ
ഊർന്നു വീണു
( വന്നല്ലോ...)`
        },
        {
            id: 15,
            title: "ഗബ്രിയേലിന്റെ ദര്‍ശനസാഫല്യമായ്",
            content: `ഗബ്രിയേലിന്റെ ദര്‍ശനസാഫല്യമായ്..
സർവ്വലോകർക്കും നന്മയേകും കാരുണ്യമായ്
ബെത്‌ലഹേമിന്റെ മാറിലൊരാരോമൽ ഉണ്ണി പിറന്നല്ലോ (3)
വിണ്ണിൽ താരകൾ പുഞ്ചിരി തൂകി
മണ്ണിൽ ഗ്ലോറിയ നാദങ്ങൾ പാടി (2)
അവൻ പള്ളിക്കച്ച അണിഞ്ഞിട്ട് കണ്ണുംചിമ്മി തുറന്നിട്ട്
കുഞ്ഞിക്കാലിട്ടടിക്കുകയായ് ..
എന്നും ആഘോഷം ഉണരുകയായ് (2)

രാജാധിരാജനേ എന്റെ മാർഗ്ഗദീപമേ
എൻ ജീവധാരയിൽ ചൈതന്യമാകണേ
ഉൾക്കൂട്ടിലെ പുൽപ്പായയിൽ
കനിവായ് വാഴണേ
(ഗബ്രിയേലിന്റെ ദര്‍ശനസാഫല്യമായ്)

ഹേ.. ദൂരെനിന്നും തങ്കത്തിൽ
സമ്മാനങ്ങൾ കൊണ്ടെത്തി.
രാജാക്കന്മാർ ഒന്നായ് നീളെ
വാഴ്ത്തിപ്പാടി.. യേ.. ഹല്ലേലൂയാ ...
എന്നും നിന്നെ ലോകത്തായ്‌
ഉള്ളോരെല്ലാം വാഴ്ത്തുന്നേ
ഇന്നും നിന്റെ സ്നേഹത്താലേ
ധന്യം ധന്യം വാണീടുന്നെ   
രാജാധിരാജനേ എന്റെ മാർഗ്ഗദീപമേ
എൻ ജീവധാരയിൽ ചൈതന്യമാകണേ
ഉൾക്കൂട്ടിലെ പുൽപ്പായയിൽ
കനിവായ് വാഴണേ`
        },
        {
            id: 16,
            title: "സംഭ്രമമൊടു tune Samkritha Pamagari (സംകൃത പമഗരി തംഗ തുംഗ)",
            content: ` സംഭ്രമമൊടു പരിഭ്രമമൊടു ആട്ടിടയർ
ഞെട്ടിയുണർന്നീടുന്ന നേരം
മേലെ വിണ്ണിൻ്റെ വിരിമാറിൽ
അൽഭുതമേറും കാഴ്ചയുമായ്
വന്നിടും ഒരു പുതു താരം (സംഭ്രമമൊടു ..

ഇമ്പമായ് ഉള്ളൊരു വാർത്ത വാനിൽ കേട്ടൊ
നേരത്ത്
അത്ഭുതം തുടിക്കുന്ന താരം മിന്നിയ നേരത്ത്
കൊടും മഞ്ഞിൻ തണുപ്പുള്ള ഇന്നീ പാതിര നേരത്ത്
പിറന്നു ..... ഉണ്ണിയേശു മശിഹ
പശുക്കൂട്ടിൽ പിറന്നു
ലോക മർത്യർ തന്നുടെ പാപമകറ്റാൻ 
വന്നു..
ഉണ്ണി മശിഹാ
ഇന്ന് ..
ബേത്ലഹേമിൽ രക്ഷ 
നൽകിടുവാനായ്
നാഥനെ കണ്ടു വണങ്ങിടുവാനായ് പോകുന്ന
അവർ രക്ഷകജനനം പാടികൊണ്ടിതാ പോകു
ലോകർ ആമോദത്തോടൊത്തുചേർന്ന്
നാഥനെ സ്തുതിച്ചിട്ടുന്നു (സംഭ്രമമൊടു) `
        }, {
            id: 17,
            title: "മാളോരേ ... മാളോരേ tune പെണ്ണാളേ പെണ്ണാളേ",
            content: `മാളോരേ ... മാളോരേ
യേശുനാഥൻ ജാതനായ് പുൽ കൂട്ടിൽ (2 )
മാനവ രൂപം എടുത്താലോ 
ബേത്ലഹേമിലെ ഗോശാലയിൽ
ഹൊയ്... -ഹൊയ്.... (മാളോരേ)

[tune ................................തന്തന തന്തന തന്താന]]
വന്ദനം വന്ദനം പാടിടാം 
നാഥനെ  വാഴ്ത്തി വണ്ണങ്ങിടാം (2 )

[fast tune ..................................മാനത്ത് പറക്കണ ചെമ്പരുന്തേ]

ദൈവത്തിൽ പുത്രനാം യേശു ദേവൻ ഓ ....
മാറിയതിന് പുത്രനാം ഉണ്ണിയേശു 
ബെത്തിലഹേമിലെ കാലിത്തൊഴുത്തിലായ് 
കന്യക മേരി തൻ ഓമന പുത്രനായ 
പാതിരാ വേളയിൽ ജാതനായി ഓ ...
മാനവ രക്ഷകൻ ജാതനായി 

[slow tune ................................പണ്ടൊരു മുക്കുവന്‍ മുത്തിന് പോയി] 
മണ്ണിതിൽ രക്ഷകൻ വന്നൊരു നേരം 
അത്ഭുത തരകം  വാനിലുദിച്ചു ലാ ......
അതു കണ്ടു ഇടയന്മാർ മോദമോടെ ലാ 
ബെത്തിലഹേമിൽ വന്നണഞ്ഞു 

മ്ശിഹാ രാജനെ കണ്ടപ്പോൾ 
തിരുവുൽ കാഴ്ചകൾ അർപ്പിച്ചു 
ഹൊയ്... -ഹൊയ്.
ആമോദം പൂണ്ടവർ 
നാഥനെ വാഴ്യ്ത്തി വണങ്ങുന്നു   

വന്ദനം വന്ദനം പാടിടാം 
നാഥനെ  വാഴ്ത്തി വണ്ണങ്ങിടാം  (2 )
(മാളോരേ ... മാളോരേ)
`
        }, {
            id: 18,
            title: "ചന്ദ്രനും താരങ്ങളും",
            content: `ചന്ദ്രനും താരങ്ങളും
തെളിയുന്ന ശീതളരാവിൽ
ലോകത്തിൻ പാലകനായി
ഉയിരേകും നാഥൻ പിറന്നേ

വരുവിൻ വരുവിൻ മോദമോടെ
പുൽകൂട്ടിൽ ചെന്നൊന്നു കണ്ടീടാം (2)
കൈകളനക്കി മെല്ലെ കണ്ണു തുറന്നു
കുഞ്ഞി ലോകത്തിൻ മുത്തായി തീർന്നീടുന്നു
മറിയത്തിൻ മകനായി മാലോകർക്കെല്ലാമീ
സ്നേഹത്തിൻ വചനങ്ങൾ നൽകീടുവാൻ (2)
ഭൂലോകവും ഈ മാലോകരും
കൂട്ടായി നിന്നെ സ്‌തുതിച്ചിടുന്നു (2)
ലാ ലാ ലാ ലാ ല ല ലാ ലാ ലാ ലാ
ലാ ലാ ലാ ലാ ല ല ലാ ലാ ലാ ലാ
(2)

ലോകമുണർന്നു നീതി സൂര്യനുദിച്ചു
ജീവ താളം മുറുകുമാ ബെതലെമിൽ
ജോസഫും മേരിയുമീ നാടിനു പുണ്യമായ്
പുൽകൂട്ടിൽ കാവലേറും മാലാഖയും
ഭൂലോകവും ഈ മാലോകരും
കൂട്ടായി നിന്നെ സ്‌തുതിച്ചിടുന്നു
ലാ ലാ ലാ ലാ ലല ലാലാ ലാ ലാ
ലാ ലാ ലാ ലാ ലല ലാ ലാ ലാ ലാ (2)`
        },
        {
            id: 19,
            title: "ബെത്‌ലഹേം  നാടിൻറെ ഗോശാല tune ennadi rakkamma എന്നടി റാക്കമ്മ ",
            content: `ബെത്‌ലഹേം  നാടിൻറെ ഗോശാല തന്നിൽ 
ഉണ്ണി മ്ശിഹാ പിറന്നു 
കന്യക മേരി തൻ പൊന്നു മകനായ് 
പുൽക്കൂട്ടിൽ വന്നു പിറന്നു 

മാലോകർ തന്നുടെ പാപമകറ്റാൻ 
ഉണ്ണി മനുഷ്യനായി അവതരിച്ചു  (2)
രാജാക്കർ  മൂവരും വന്നണഞ്ഞു 
അവർ  കാഴ്ചകൾ  വെച്ചു  വണങ്ങി (2)

(ബെത്‌ലഹേം  നാടിൻറെ......)

ഇന്നാണ് പുൽക്കൂട്ടിൽ പിറന്നാൾ 
എങ്ങും സ്വർഗീയ ഗാനമുണർന്നു (2) 
പാരാകെ  നിൻ  നാമം സ്തുതിച്ചുപാടി  
ആ  നാമത്തിൽ പുളകിതരായി (2)

(ബെത്‌ലഹേം  നാടിൻറെ......)
`
        }, {
            id: 20,
            title: "ദൂതരെ പാടിടുവിൻ",
            content: `ദൂതരെ പാടിടുവിൻ
മോദമായി മണ്ണിലിന്നു
രാജാധിരാജാവു പിറന്നു
പൂമണം ചൊരിയാത്ത പൂമെത്ത ഇല്ലാത്ത
ബെ‌ലെം കാലിക്കൂട്ടിൽ (2)
 (ദൂതരെ)

സൂര്യനുണരും മുൻപേ
ചന്ദ്രനണയും മുൻപേ
ലോകത്തിൻ പാലകനായി ദൈവകുമാരനിന്നു
മണ്ണിലവതരിച്ചു
(2)

പാടി പാടി പാടി പാടി പാടി വാഴ്ത്തീടാം
താള മേള വാദ്യ ഘോഷ സംഗ്ഗത്തോടൊപ്പം
ഈ മണ്ണേ സ്നേഹിച്ച ദൈവത്തിൻ പുത്രനെ
ആവോളം നമിച്ചീടാം )(2)
( ദൂതരെ)

ലോകമറിയും മുൻപേ
കാലങ്ങൾ മാറും മുൻപേ
ദേവാധി ദേവാനാം കന്യാതനയാനീ
പുൽക്കൂട്ടിൽ അവതരിച്ചു
വാഴ്ത്തി വാഴ്ത്തി വാഴ്ത്തി വാഴ്ത്തി വാഴ്ത്തി പാടിടാം
താള മേള വാദ്യ ഘോഷ സംഗ്ഗത്തോടൊപ്പം
ഈ മണ്ണേ സ്നേഹിച്ച ദൈവത്തിൻ പുത്രനെ
ആവോളം നമിച്ചീടാം (2) 
(ദൂതരെ)`
        },
        {
            id: 21,
            title: "ദൂതരെ പാടിടുവിൻ",
            content: `ദൂതരെ പാടിടുവിൻ
മോദമായി മണ്ണിലിന്നു
രാജാധിരാജാവു പിറന്നു
പൂമണം ചൊരിയാത്ത പൂമെത്ത ഇല്ലാത്ത
ബെ‌ലെം കാലിക്കൂട്ടിൽ (2)
 (ദൂതരെ)

സൂര്യനുണരും മുൻപേ
ചന്ദ്രനണയും മുൻപേ
ലോകത്തിൻ പാലകനായി ദൈവകുമാരനിന്നു
മണ്ണിലവതരിച്ചു
(2)

പാടി പാടി പാടി പാടി പാടി വാഴ്ത്തീടാം
താള മേള വാദ്യ ഘോഷ സംഗ്ഗത്തോടൊപ്പം
ഈ മണ്ണേ സ്നേഹിച്ച ദൈവത്തിൻ പുത്രനെ
ആവോളം നമിച്ചീടാം )(2)
( ദൂതരെ)

ലോകമറിയും മുൻപേ
കാലങ്ങൾ മാറും മുൻപേ
ദേവാധി ദേവാനാം കന്യാതനയാനീ
പുൽക്കൂട്ടിൽ അവതരിച്ചു
വാഴ്ത്തി വാഴ്ത്തി വാഴ്ത്തി വാഴ്ത്തി വാഴ്ത്തി പാടിടാം
താള മേള വാദ്യ ഘോഷ സംഗ്ഗത്തോടൊപ്പം
ഈ മണ്ണേ സ്നേഹിച്ച ദൈവത്തിൻ പുത്രനെ
ആവോളം നമിച്ചീടാം (2) 
(ദൂതരെ)`
        },{
            id: 22,
            title: "മയിലുകളെ കുയിലുകളെ",
            content: `മയിലുകളെ കുയിലുകളെ
ആർത്തു പാടുവിൻ
രാജാധി രാജാവായ് പിറന്നതല്ലേ
എന്റെ പൊന്നല്ലെ
എന്റെ മുത്തല്ലേ
എന്റെ കണ്ണോലും കണ്മണിയല്ലേ (2)
(മയിലുകളെ )

പണ്ടോരു രാത്രിയിൽ പാവന നാളിതിൽ
പ്രവചനമായ് മൊഴിഞ്ഞു
കുന്നിന്റെ ചോട്ടിലെ പാവന പുൽക്കൂട്ടിൽ
ദൈവമായ് പിറക്കുമെന്ന് (2)

തക്ക് തക്ക് തക്ക് തക്ക് തക്കരം പാടീടാം
തക്ക് തക്ക് തക്ക് തക്ക് തക്കരം പാടീടാം
പൈതലേ പാടി ഉറക്കാം
(മയിലുകളെ കുയിലുകളെ)

മഞ്ഞുള്ള പാതയിൽ മാനവ രക്ഷകൻ
അനുഗ്രഹമായി നിറഞ്ഞു
മാമല മേട്ടിലെ ആകാശവീഥിയിൽ
നവതാരം തെളിഞ്ഞുവന്നു (2)

തക്ക് തക്ക് തക്ക് തക്ക് തക്കരം പാടീടാം
തക്ക് തക്ക് തക്ക് തക്ക് തക്കരം പാടീടാം
പൈതലേ പാടി ഉറക്കാം(2) 
(മയിലു)`
        }

    ];

    return (
        <>
            <GuestHeader />
            <div className="christmas-songs-container">
                <div className="container py-5">
                    {/* Page Header */}
                    <div className="page-header text-center mb-5">
                        <h1 className="page-title">
                            <i className="fas fa-music me-3"></i>
                            Christmas Songs
                        </h1>
                        <p className="page-subtitle">Malayalam Carol Lyrics</p>
                        <button
                            className="download-pdf-btn btn btn-danger mt-3"
                            onClick={handleDownloadPDF}
                        >
                            <i className="fas fa-download me-2"></i>Download as PDF
                        </button>
                    </div>

                    {/* Songs Grid */}
                    <div className="songs-wrapper" ref={contentRef}>
                        {songs.map((song, index) => (
                            <div key={song.id} className="song-card">
                                <div className="song-watermark">
                                    <img src="./assets/images/logo_custom_new_trans.png" alt="Church Logo" />
                                </div>
                                <div className="song-header">
                                    <div className="song-number">
                                        <i className="fas fa-music"></i>
                                        <span>Song {song.id}</span>
                                    </div>
                                    <h2 className="song-title">{song.title}</h2>
                                </div>
                                <div className="song-body">
                                    <div className="song-content">
                                        {song.content}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <GuestFooter />
        </>
    );
}

export default GuestChristmasSongs;
